<template>
	<Row v-if="ladder.length" class="d-flex justify-content-between flex-wrap" :gutter="16">
		<Col v-for="(match, ind) in ladder" :md="{span: 12}" :lg="{ span: 8 }" class="mt-3" :key="match._id + '_' + ind">
			<Card class="tournament-stage table-card-style">
				<table class="match-table">
					<thead>
						<tr class="first-table-row">
							<th colspan="2" class="match-th-style">
								<span>{{ match.title }}</span>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr
							:class="`${
								getPoints(match.home_players, match, match.home_team) > getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
							}`"
						>
							<td>
								<span v-if="matches.length">{{ match.home_team.name }}</span>
							</td>
							<td class="position-relative">
								<span v-if="matches.length">
									{{ getPoints(match.home_players, match, match.home_team) }}
								</span>
								<Icon role="button" type="md-information-circle" class="icon-pos" @click="() => openPlayoffModal(match, ladder)" />
							</td>
						</tr>
						<tr
							:class="`${
								getPoints(match.home_players, match, match.home_team) < getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
							}`"
						>
							<td>
								<span v-if="matches.length">
									{{ match.away_team.name }}
								</span>
							</td>
							<td class="position-relative w-70px">
								<span v-if="matches.length">
									{{ getPoints(match.away_players, match, match.away_team) }}
								</span>
							</td>
						</tr>
					</tbody>
				</table>
			</Card>
		</Col>
	</Row>
</template>

<script>
	import storeMixin from '../storeMixin';

	export default {
		name: 'Stepladder',
		components: {},
		// props: ['ladder', 'matches'],
		data() {
			return storeMixin;
		},
	};
</script>

<style scoped>
	.table-card-style {
		/* width: 300px; */
		height: 100%;
		box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
	}

	.table-card-style:hover {
		box-shadow: 0 1px 6px rgba(0, 0, 0, 0.4);
	}
	.match-table {
		width: 100%;
		/* max-width: 400px;
		border-collapse: collapse; */
	}

	.table-margin {
		margin: 30px 0px;
	}

	.w-60px {
		width: 60px;
		height: 36px;
	}

	.w-300px {
		width: 300px;
		height: 36px;
	}

	.match-table th,
	.match-table td {
		padding: 0.6rem 0.75rem;
		border: 1px solid #eff2f7;
	}

	.match-table.table-bordered tr td,
	.match-table.table-bordered tr th {
		border-width: 1px !important;
	}

	.match-table.table-bordered td {
		border: none !important;
	}

	.tournament-stage .match-table td:hover {
		background: transparent !important;
	}
	.match-table td:hover {
		background: #e4e4e4;
	}

	.icon-pos {
		position: absolute;
		bottom: -0.5rem;
		left: -0.5rem;
		color: #2d8cf0;
		z-index: 10;
		font-size: 20px;
		background: white;
		border-radius: 50%;
		width: 16px;
		height: 16px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.icon-pos:hover {
		transform: scale(1.15);
	}

	.first-table-row th {
		background: var(--bg-darkness);
		color: var(--text-color);
		border-color: var(--bg-darkness);
	}
</style>



// WEBPACK FOOTER //
// src/components/competitions/schemes/formats/groups/Stepladder.vue